import * as React from 'react';
import { Props } from '..';

const ChevronUp: React.FC<Props> = ({
  color = 'currentColor',
  strokeWidth = 2.044,
  ...props
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M22.4 17.2L12 6.8 1.6 17.2"
    />
  </svg>
);

export default ChevronUp;
